const fetchRegionsAndPassIntoState = self => {
  let key = 0;
  fetch('https://covid-api.quintessential.gr/data')
  .then(res => res.json())
  .then(array => {
    
    const states = {};
    array = array.filter(e => {
      if (states[e['Province/State']] === true) {
        return false;
      } else if (e['Country/Region'] === 'US') {
        states[e['Province/State']] = true; 
      }
      return true;
    });

    


    console.log(array);
    array.forEach(e => {
      e['key'] = key;
      e['latitude'] = e.Latitude;
      e['longitude'] = e.Longitude;
      e['deaths'] = e.Deaths;
      e['cured'] = e.Recovered;
      e['active'] = e.Active;
      e['total'] = e.Confirmed;
      e['country'] = e['Country/Region'];
      e['province'] = e['Province/State'];
      key++;
    });

    let deaths = 0, cured = 0, total = 0;
    array.map(e => {
      deaths += parseInt(e.deaths) || 0;
      cured += parseInt(e.cured) || 0;
      total += parseInt(e.total) || 0;
    });

    self.setState(prevState => {
      return {
      data: [
        ...prevState.data,
        ...array,
      ],
      worldStat: {
        deaths,
        cured,
        total,
      }
    };
  })});
  fetch('https://roamiiing-101coronavirus-backend.glitch.me/api/regionsstat')
  .then(res => res.json())
  .then(array => {
    array.forEach(e => {
      e['key'] = key;
      key++;
    });
    self.setState(prevState => {
      return {
        data: [
          ...prevState.data,
          ...array
        ],
      };
    });
  });
}

function getRussianStatAndPassIntoState(self) {
  fetch('https://roamiiing-101coronavirus-backend.glitch.me/api/regionsstat')
    .then(res => res.json())
    .then(json => self.setState({
      regionsStat: json,
    }));

  fetch('https://roamiiing-101coronavirus-backend.glitch.me/api/russiastat')
    .then(res => res.json())
    .then(json => self.setState({
      russianStat: json,
    }));

}

export { fetchRegionsAndPassIntoState, getRussianStatAndPassIntoState };
